// extracted by mini-css-extract-plugin
module.exports = {"container":"uploadArea_container__3ey2g","upload":"uploadArea_upload__2MKSC","icon":"uploadArea_icon__2QKMU"};